import React, { Component } from 'react'
import ReactTooltip from "react-tooltip";
import "./SectionShortcut.css"
import './SectionsShortcut.scss'

class SectionShortcut extends Component {
    render() {
        let activeDot = this.props.activeDot ? 'zoomCircle btn--shockwave is-active' : 'zoomCircle'
        let activeDotIns = this.props.activeDot ? 'zoomCircleChild btn--shockwaveIns is-active' : 'zoomCircleChild'
        return (
            <div className="section-shortcut" onClick={() => this.props.onClick(this.props.eventKey)}>
                <div data-tip={this.props.title} title={this.props.title} className={activeDot}>
                    <div title={this.props.title} className={activeDotIns}></div>
                </div>
                <ReactTooltip place="right" type="dark" effect="solid" />
            </div>
        )
    }
}
export default SectionShortcut
